<template>
  <v-form>
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Edit Garage {{ value.location }}</v-toolbar-title>
        <slot name="header"></slot>
      </v-toolbar>
      <v-tabs v-model="tab">
        <v-tab>Notifications</v-tab>
        <v-tab>Opening/Closing Hours</v-tab>
        <v-tab>Settings</v-tab>
        <v-tab>Roles</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-row>
                    <v-col cols="auto">
                      <h3 class="subtitle-1">Metric Validation Notification Emails</h3>
                    </v-col>
                    <v-col class="d-flex align-center">
                      <v-icon small @click="metricValidationEmailsExpanded = !metricValidationEmailsExpanded">mdi-information</v-icon>
                      <v-expand-transition>
                        <div v-if="metricValidationEmailsExpanded" class="ml-2">
                          These addresses receive the "Summary of rejected" email, sent nightly at 3am
                        </div>
                      </v-expand-transition>
                    </v-col>
                  </v-row>
                </v-flex>
                <v-flex xs12>
                  <v-combobox
                    :delimiters="[',', ';', ' ']"
                    v-model="value.metricValidationEmails"
                    :items="[]"
                    label="Metric Validation Email Addresses"
                    multiple
                    chips
                    deletable-chips
                    v-validate="'email-addresses'"
                    append-icon
                    name="metric email addresses"
                    :error-messages="errors.first('metric email addresses')"
                  ></v-combobox>
                </v-flex>
                <v-flex xs12>
                  <v-combobox
                    :delimiters="[',', ';', ' ']"
                    v-model="value.metricValidationCCEmails"
                    :items="[]"
                    label="Metric Validation CC Email Addresses"
                    multiple
                    chips
                    deletable-chips
                    v-validate="'email-addresses'"
                    append-icon
                    name="metric cc email addresses"
                    :error-messages="errors.first('metric cc email addresses')"
                  ></v-combobox>
                </v-flex>
                <v-flex xs12>
                  <v-row>
                    <v-col cols="auto">
                      <h3 class="subtitle-1">Escalation Notification Emails</h3>
                    </v-col>
                    <v-col class="d-flex align-center">
                      <v-icon small @click="escalationEmailsExpanded = !escalationEmailsExpanded">mdi-information</v-icon>
                      <v-expand-transition>
                        <div v-if="escalationEmailsExpanded" class="ml-2">
                          These addresses receive the "Out of Operating Hours" email, sent every 5 minutes, and "Summary of overdue tasks" sent nightly at 3am
                        </div>
                      </v-expand-transition>
                    </v-col>
                  </v-row>
                </v-flex>
                <v-flex xs12>
                  <v-combobox
                    :delimiters="[',', ';', ' ']"
                    v-model="value.escalationEmails"
                    :items="[]"
                    label="Escalation Email Addresses"
                    multiple
                    chips
                    deletable-chips
                    v-validate="'email-addresses'"
                    append-icon
                    name="escalation email addresses"
                    :error-messages="errors.first('escalation email addresses')"
                  ></v-combobox>
                </v-flex>
                <v-flex xs12>
                  <v-combobox
                    :delimiters="[',', ';', ' ']"
                    v-model="value.escalationCCEmails"
                    :items="[]"
                    label="Escalation CC Email Addresses"
                    multiple
                    chips
                    deletable-chips
                    v-validate="'email-addresses'"
                    append-icon
                    name="escalation cc email addresses"
                    :error-messages="errors.first('escalation cc email addresses')"
                  ></v-combobox>
                </v-flex>
                <v-flex xs12>
                  <v-row>
                    <v-col cols="auto">
                      <h3 class="subtitle-1">Shift Summary Email Recipients</h3>
                    </v-col>
                    <v-col class="d-flex align-center">
                      <v-icon small @click="shiftSummaryEmailsExpanded = !shiftSummaryEmailsExpanded">mdi-information</v-icon>
                      <v-expand-transition>
                        <div v-if="shiftSummaryEmailsExpanded" class="ml-2">
                          These addresses receive the "Shift Summary" email, sent between 2-3 hours after shift end
                        </div>
                      </v-expand-transition>
                    </v-col>
                  </v-row>
                </v-flex>
                <v-flex xs12>
                  <v-combobox
                    :delimiters="[',', ';', ' ']"
                    v-model="value.shiftSummaryEmails"
                    :items="[]"
                    label="Shift Summary Email Addresses"
                    multiple
                    chips
                    deletable-chips
                    v-validate="'email-addresses'"
                    append-icon
                    name="daily summary email addresses"
                    :error-messages="errors.first('daily summary email addresses')"
                  ></v-combobox>
                </v-flex>
                <v-flex xs12>
                  <v-row>
                    <v-col cols="auto">
                      <h3 class="subtitle-1">Snapshot of Inbound Defects Email Recipients</h3>
                    </v-col>
                    <v-col class="d-flex align-center">
                      <v-icon small @click="digestOfInboundDefectsEmailsExpanded = !digestOfInboundDefectsEmailsExpanded">mdi-information</v-icon>
                      <v-expand-transition>
                        <div v-if="digestOfInboundDefectsEmailsExpanded" class="ml-2">
                          These addresses receive the "Snapshot of inbound defects", sent every 60 minutes
                        </div>
                      </v-expand-transition>
                    </v-col>
                  </v-row>
                </v-flex>
                <v-flex xs12>
                  <v-combobox
                    :delimiters="[',', ';', ' ']"
                    v-model="value.digestOfInboundDefectsEmails"
                    :items="[]"
                    label="Snapshot of Inbound Defects"
                    multiple
                    chips
                    deletable-chips
                    v-validate="'email-addresses'"
                    append-icon
                    name="digest of inbound defects email addresses"
                    :error-messages="errors.first('digest of inbound defects email addresses')"
                  ></v-combobox>
                </v-flex>
                <v-flex xs12>
                  <v-row>
                    <v-col cols="auto">
                      <h3 class="subtitle-1">Safety Related Defects Email Recipients</h3>
                    </v-col>
                    <v-col class="d-flex align-center">
                      <v-icon small @click="safetyRelatedDefectsEmailsExpanded = !safetyRelatedDefectsEmailsExpanded">mdi-information</v-icon>
                      <v-expand-transition>
                        <div v-if="safetyRelatedDefectsEmailsExpanded" class="ml-2">
                          These addresses receive the "Safety related defects", sent every 5 minutes
                        </div>
                      </v-expand-transition>
                    </v-col>
                  </v-row>
                </v-flex>
                <v-flex xs12>
                  <v-combobox
                    :delimiters="[',', ';', ' ']"
                    v-model="value.safetyRelatedDefectsEmails"
                    :items="[]"
                    label="Safety Related Defects"
                    multiple
                    chips
                    deletable-chips
                    v-validate="'email-addresses'"
                    append-icon
                    name="safety related defects email addresses"
                    :error-messages="errors.first('safety related defects email addresses')"
                  ></v-combobox>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-tab-item>
        <v-tab-item>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <h3 class="subtitle-1">Timezone</h3>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete v-model="value.timezone" :items="timezones" />
                </v-flex>
                <v-flex xs12>
                  <h3 class="subtitle-1">Workshop Operation Hours</h3>
                  <v-row v-for="(day, index) in daysOfWeek" :key="index" class="mb-4">
                    <v-col cols="1">
                      <v-checkbox v-model="schedules[index].isOpen"></v-checkbox>
                    </v-col>
                    <v-col cols="1">
                      <v-text-field readonly :value="day"></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-menu
                        v-model="menu1[index]"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="schedules[index].openingTime"
                            label="Opening Time (HH:MM)"
                            prepend-icon="mdi-clock"
                            v-bind="attrs"
                            v-on="on"
                            v-validate="'military-time'"
                            :error-messages="errors.first('openingTime')"
                            readonly
                          ></v-text-field>
                        </template>
                        <v-card>
                          <v-time-picker
                            v-if="menu1[index]"
                            v-model="schedules[index].openingTime"
                            format="24hr"
                            @click:minute="menu1[index] = false"
                          ></v-time-picker>
                        </v-card>
                      </v-menu>
                    </v-col>
                    <v-col cols="4">
                      <v-menu
                        v-model="menu2[index]"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="schedules[index].closingTime"
                            label="Closing Time (HH:MM)"
                            prepend-icon="mdi-clock"
                            v-bind="attrs"
                            v-on="on"
                            v-validate="'military-time'"
                            :error-messages="errors.first('closingTime')"
                            readonly
                          ></v-text-field>
                        </template>
                        <v-card>
                          <v-time-picker
                            v-if="menu2[index]"
                            v-model="schedules[index].closingTime"
                            format="24hr"
                            @click:minute="menu2[index] = false"
                          ></v-time-picker>
                        </v-card>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-tab-item>
        <v-tab-item>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <h3 class="subtitle-1">Calendar Preview Bands (defects calendar preview)</h3>
                </v-flex>
                <v-flex xs2>
                  <v-text-field
                    v-model="value.calendarUtilisationBands[0]"
                    label="Green"
                    type="number"
                    v-validate="'min_value:1|bands:' + value.calendarUtilisationBands[1]"
                    name="band 1"
                    :error-messages="errors.first('band 1')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs2>
                  <v-text-field
                    v-model="value.calendarUtilisationBands[1]"
                    label="Amber"
                    type="number"
                    v-validate="'min_value:2|bands:' + value.calendarUtilisationBands[2]"
                    name="band 2"
                    :error-messages="errors.first('band 2')"
                    min
                  ></v-text-field>
                </v-flex>
                <v-flex xs2>
                  <v-text-field
                    v-model="value.calendarUtilisationBands[2]"
                    label="Red"
                    type="number"
                    v-validate="'min_value:3'"
                    name="band 3"
                    :error-messages="errors.first('band 3')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <h3 class="subtitle-1">Allow/disallow workshop mechanics to assign themselves to unassigned defects</h3>
                </v-flex>
                <v-flex xs12>
                  <v-checkbox v-model="value.allowWorkshopTechniciansSelfAssignUnassignedDefects" />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-tab-item>
        <v-tab-item>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-autocomplete
                    :delimiters="[',', ';', ' ']"
                    v-model="value.managers"
                    item-value="id"
                    item-text="displayName"
                    :items="users"
                    label="Workshop Managers"
                    multiple
                    chips
                    deletable-chips
                    append-icon
                    name="managers"
                    :loading="$wait.is('loading users')"
                    :error-messages="errors.first('managers')"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                    v-model="value.supervisors"
                    item-value="id"
                    item-text="displayName"
                    :items="users"
                    label="Workshop Supervisors"
                    multiple
                    chips
                    deletable-chips
                    append-icon
                    name="supervisors"
                    :loading="$wait.is('loading users')"
                    :error-messages="errors.first('supervisors')"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                    v-model="value.technicians"
                    item-value="id"
                    item-text="displayName"
                    :items="users"
                    label="Workshop Technicians"
                    multiple
                    chips
                    deletable-chips
                    append-icon
                    name="technicians"
                    :loading="$wait.is('loading users')"
                    :error-messages="errors.first('technicians')"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                    v-model="value.apprentices"
                    item-value="id"
                    item-text="displayName"
                    :items="users"
                    label="Apprentices"
                    multiple
                    chips
                    deletable-chips
                    append-icon
                    name="apprentices"
                    :loading="$wait.is('loading users')"
                    :error-messages="errors.first('apprentices')"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>

      <v-card-actions>
        <v-spacer></v-spacer>
        <slot name="actions"></slot>
        <v-btn
          color="primary"
          :disabled="submitted || disableSubmit"
          @click="submit"
          :loading="submitted"
        >Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import { VclList } from 'vue-content-loading';
import GarageLocations from '../GarageLocations/GarageLocationsClient.vue';
import Users from '../Users/UsersClient.vue';
import FormValidation from '../FormValidation.vue';
import { Validator } from 'vee-validate';
import moment from 'moment-timezone';

export default {
  props: {
    value: {
      required: true
    }
  },
  components: {
    VclList
  },
  mixins: [FormValidation, Users, GarageLocations],
  data() {
    return {
      tab: null,
      users: [],
      submitted: false,
      daysOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      timezones: moment.tz.names(),
      menu1: Array(7).fill(false),
      menu2: Array(7).fill(false),
      metricValidationEmailsExpanded: false,
      escalationEmailsExpanded: false,
      shiftSummaryEmailsExpanded: false,
      digestOfInboundDefectsEmailsExpanded: false,
      safetyRelatedDefectsEmailsExpanded: false,
    };
  },
  computed: {
    schedules() {
      return this.value.schedules.sort((a, b) => {
        return this.daysOfWeek.indexOf(a.dayOfWeek) - this.daysOfWeek.indexOf(b.dayOfWeek);
      });
    }
  },
  methods: {
    async loadUsers() {
      this.users = await this.getUsers();
    },
    async submit() {
      this.submitted = true;
      var valid = this.$validator.validate();
      if (!valid) {
        this.submitted = false;
        return;
      }
      this.complete();
    },
    complete() {
      this.$emit('submit', { value: this.value });
    },
  },
  watch: {
    value() {
      this.submitted = false;
    }
  },
  async mounted() {
    await this.loadUsers();

    const emailAddress = value => {
      // tslint:disable-next-line:max-line-length
      const emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
      if (!emailRegex.test(value)) {
        return false;
      }
      return true;
    };

    const emailAddressMulti = value => {
      var validator = emailAddress;
      var invalid = value.filter(x => validator(x) !== true);
      if (invalid.length == 0) {
        return true;
      }
      if (invalid.length == 1) {
        return `'${invalid[0]}' is not a valid email address`;
      }

      var messages = invalid.map(x => `'${x}'`).join(', ');
      return `${messages} are not valid email addresses`;
    };

    Validator.extend('email-addresses', {
      validate: value => {
        var valid = emailAddressMulti(value);
        return new Promise(resolve => {
          resolve({
            valid: valid === true,
            data: value === true ? undefined : { message: valid }
          });
        });
      },
      getMessage: (field, params, data) => data.message
    });

    Validator.extend('bands', {
      validate: (value, { max }) => {
        var valid = value < parseInt(max, 10);
        return new Promise(resolve => {
          resolve({
            valid: valid === true,
            data: value === true ? undefined : { message: 'Must be less than higher bands' }
          });
        });
      },
      getMessage: (field, params, data) => data.message,
      paramNames: ['max']
    });

    Validator.extend('military-time', {
      validate: value => {
        var valid = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(value);
        return new Promise(resolve => {
          resolve({
            valid: valid === true,
            data: valid === true ? undefined : { message: 'Invalid 24h time format' }
          });
        });
      },
      getMessage: (field, params, data) => data.message
    });
  }
};
</script>
